// import React, { useReducer } from "react";

const currentUser = localStorage.getItem("currentUser");
let user = currentUser
  ? JSON.parse(currentUser).user
  : {};
let token = currentUser
  ? JSON.parse(currentUser).auth_token
  : "";
let streamToken = currentUser
  ? JSON.parse(currentUser).stream_chat_token
  : "";

const {
  id: currentUserID,
} = user || {};

export const initialState = {
  userDetails: "" || user,
  token: "" || token,
  streamToken: "" || streamToken,
  currentUserID: "" || currentUserID,
  loading: false,
  errorMessage: null
};
 
export const AuthReducer = (initialState, action) => {
  switch (action.type) {
    case "REQUEST_REGISTER":
    case "REQUEST_LOGIN":
      return {
        ...initialState,
        loading: true
      };
    case "REGISTER_SUCCESS":
    case "LOGIN_SUCCESS":
      return {
        ...initialState,
        userDetails: action.payload.user,
        token: action.payload.auth_token,
        streamToken: action.payload.stream_chat_token,
        currentUserID: action.payload.user?.id,
        loading: false
      };
    case "LOGOUT":
      return {
        ...initialState,
        userDetails: "",
        token: "",
        streamToken: "",
        currentUserID: "",
      };
    case "REGISTER_ERROR":
    case "LOGIN_ERROR":
      return {
        ...initialState,
        loading: false,
        errorMessage: action.error
      };
 
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};